var map = {
	"./active-archie.svg": "7445",
	"./inactive-archie.svg": "2b6f",
	"./logo-archie.svg": "8f34",
	"./logo-edd.svg": "bbc3",
	"./logo-google-analytics.svg": "ea3d",
	"./logo-om.svg": "8f81"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c6e";